export var createUpdateId = function createUpdateId() {
  var _window;
  var input = new Uint32Array(12);
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!#$%^&-_0123456789';
  if (typeof window !== 'undefined' && (_window = window) !== null && _window !== void 0 && _window.crypto) {
    var output = window.crypto.getRandomValues(input);
    return output.reduce(function (acc, value) {
      return "".concat(acc).concat(characters.charAt(Math.floor(value % characters.length)));
    }, '');
  }
  return input.reduce(function (acc) {
    return "".concat(acc).concat(characters.charAt(Math.floor(Math.random() * characters.length)));
  }, '');
};